import withIntl from "../utils/withIntl";
import React from "react";
import SearchSalesArea from "../components/Reporting/SearchSalesArea";
import Grid from "@material-ui/core/Grid";
import { DateRangePicker } from "react-date-range";
import { enGB } from "react-date-range/dist/locale";
import Button from "@material-ui/core/Button";
import { getReportingData } from "../components/Reporting/ReportingApi";
import cloudStore from "../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReportingTable from "../components/Reporting/Reporting/ReportingTable";
import Typography from "@material-ui/core/Typography";

export class SalesAreaDetails {
  constructor(
    renderedName,
    spMerchantId,
    taMerchantId,
    numberOfBills,
    amount,
    amountPerPaymentType,
    revenue,
    deliveryCosts,
    deliveryCostsExVat
  ) {
    this.renderedName = renderedName;
    this.spMerchantId = spMerchantId;
    this.taMerchantId = taMerchantId;
    this.numberOfBills = numberOfBills;
    this.amountPerPaymentType = amountPerPaymentType;
    this.amount = amount;
    this.revenue = revenue;
    this.deliveryCosts = deliveryCosts;
    this.deliveryCostsExVat = deliveryCostsExVat;
  }
}

function Reporting(props) {
  const [range, setRange] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection"
  });
  const [fetching, setFetching] = React.useState(false);
  const [selectedTaMerchantIds, setSelectedTaMerchantIds] = React.useState();
  const [selectedSpMerchantIds, setSelectedSpMerchantIds] = React.useState();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [salesAreaData, setSalesAreaData] = React.useState([]);

  const handleSetMerchantIds = (selectedItems) => {
    const taIds = [];
    const spIds = [];

    selectedItems.map((item) => {
      if (item.type === "taMerchant") {
        taIds.push(item.id);
      } else if (item.type === "spMerchant") {
        spIds.push(item.id);
      }
    });
    setSelectedTaMerchantIds(taIds);
    setSelectedSpMerchantIds(spIds);
    setSelectedItems(selectedItems);
  };

  const handleReportData = (res) => {
    const addAmounts = (newSalesArea, paymentMethodKey, paymentMethod, vats, totalAmount) => {
      if (newSalesArea.amountPerPaymentType[paymentMethodKey] == null) {
        newSalesArea.amountPerPaymentType[paymentMethodKey] = { count: 0, vats: {} };
      }
      newSalesArea.amountPerPaymentType[paymentMethodKey].count++;

      Object.keys(vats).forEach((vat) => {
        let totalAmountPerVat = (vats[vat].amount * paymentMethod.amount) / totalAmount;

        if (!newSalesArea.amountPerPaymentType[paymentMethodKey].vats[vat]) {
          newSalesArea.amountPerPaymentType[paymentMethodKey].vats[vat] = {
            amountIncVat: 0,
            amountExVat: 0,
            amountVat: 0
          };
        }
        newSalesArea.amountPerPaymentType[paymentMethodKey].vats[vat].amountIncVat += totalAmountPerVat;
      });
    };

    let salesAreasDataArray = [];

    selectedItems.forEach((item) => {
      const spReceiptsPerMerchant = res.sp_receipts?.filter((receipt) => receipt.sp_merchant_id === item.id);
      const taReceiptsPerMerchant = res.ta_receipts?.filter((receipt) => receipt.ta_merchant_id === item.id);
      const allReceiptsPerMerchant = spReceiptsPerMerchant.concat(taReceiptsPerMerchant);

      let newSalesArea = new SalesAreaDetails(item.renderedName);
      newSalesArea.taMerchantId = item.type === "taMerchant" ? item.id : null;
      newSalesArea.spMerchantId = item.type === "spMerchant" ? item.id : null;
      newSalesArea.numberOfBills = allReceiptsPerMerchant.length;
      newSalesArea.amount = allReceiptsPerMerchant.reduce(
        (accumulator, currentValue) => accumulator + currentValue.reporting.total_amount_paid,
        0
      );

      newSalesArea.revenue = { total: {}, vats: {}, tipAmount: 0 };
      allReceiptsPerMerchant.forEach((receipt) => {
        if (receipt.reporting.total_amount_per_transaction?.OK?.vats) {
          let turnoverPart = 0;
          let total = 0;

          let isInhouse =
            Object.keys(receipt.reporting.total_amount_per_transaction.OK.amount_per_turnover_group).length > 0;
          Object.keys(receipt.reporting.total_amount_per_transaction.OK.amount_per_turnover_group).forEach(
            (turnoverGroupKey) => {

              total +=
                receipt.reporting.total_amount_per_transaction.OK.amount_per_turnover_group[turnoverGroupKey].amount;


              if (
                receipt.reporting.total_amount_per_transaction.OK.amount_per_turnover_group[turnoverGroupKey]
                  .is_turnover !== 0
              ) {

                turnoverPart +=
                  receipt.reporting.total_amount_per_transaction.OK.amount_per_turnover_group[turnoverGroupKey].amount;
              }
            }
          );

          let totalNotZeroVat = 0;
          Object.keys(receipt.reporting.total_amount_per_transaction?.OK?.vats).filter(vat => Number(vat) != 0).forEach((vat) => {
            totalNotZeroVat += receipt.reporting.total_amount_per_transaction.OK.vats[vat].amount;
          });
          Object.keys(receipt.reporting.total_amount_per_transaction?.OK?.vats).forEach((vat) => {
            let totalAmountPerVat = receipt.reporting.total_amount_per_transaction.OK.vats[vat].amount;

            if (isInhouse && Number(vat) != 0 && totalNotZeroVat != 0) {

              const notTurnoverPart = total - turnoverPart;

              totalAmountPerVat -= totalAmountPerVat / totalNotZeroVat * notTurnoverPart;
            }

            if (totalAmountPerVat === 0) {
              return true;
            }
            if (receipt.amount_refunded == null) {
              receipt.amount_refunded = 0;
            }
            let amountIncVat =
              totalAmountPerVat +
              (totalAmountPerVat / receipt.reporting.total_amount_paid) * receipt.amount_refunded * -1;
            if (!newSalesArea.revenue.vats[vat]) {
              newSalesArea.revenue.vats[vat] = { amountIncVat: 0, amountExVat: 0, amountVat: 0 };
            }
            newSalesArea.revenue.vats[vat].amountIncVat += amountIncVat;
          });
        }
        newSalesArea.revenue.tipAmount += receipt.reporting.tip_amount ?? 0;
      });

      Object.keys(newSalesArea.revenue.vats).forEach((vat) => {
        newSalesArea.revenue.vats[vat].amountExVat = Math.round(
          newSalesArea.revenue.vats[vat].amountIncVat / (1 + Number(vat))
        );
        newSalesArea.revenue.vats[vat].amountVat =
          newSalesArea.revenue.vats[vat].amountIncVat - newSalesArea.revenue.vats[vat].amountExVat;
      });

      newSalesArea.revenue.total = { amountIncVat: 0, amountExVat: 0, amountVat: 0 };
      Object.keys(newSalesArea.revenue.vats).forEach((vat) => {
        if (vat === "total") {
          return;
        }
        newSalesArea.revenue.total.amountExVat += newSalesArea.revenue.vats[vat].amountExVat;
        newSalesArea.revenue.total.amountVat += newSalesArea.revenue.vats[vat].amountVat;
        newSalesArea.revenue.total.amountIncVat += newSalesArea.revenue.vats[vat].amountIncVat;
      });

      newSalesArea.amountPerPaymentType = {};
      allReceiptsPerMerchant.forEach((receipt) => {
        let totalAmount = receipt.reporting.total_amount_paid;

        if (receipt.payment_method && receipt.reporting) {
          if (newSalesArea.amountPerPaymentType[receipt.payment_method] == null) {
            newSalesArea.amountPerPaymentType[receipt.payment_method] = { count: 0, vats: {} };
          }

          let paymentMethodKey = receipt.payment_method;
          let paymentMethod = {
            amount: receipt.reporting.total_amount_paid
          };

          addAmounts(
            newSalesArea,
            paymentMethodKey,
            paymentMethod,
            receipt.reporting.total_amount_per_transaction.OK.vats,
            totalAmount
          );
          if (receipt.amount_refunded > 0) {
            let paymentMethodKey = "REFUNDED";
            let paymentMethod = { amount: receipt.amount_refunded * -1 };

            addAmounts(
              newSalesArea,
              paymentMethodKey,
              paymentMethod,
              receipt.reporting.total_amount_per_transaction.OK.vats,
              totalAmount
            );
          }
        } else {
          // inhouse receipt
          if (receipt.reporting?.total_amount_paid > 0) {
            Object.keys(receipt.reporting.total_amount_per_transaction.OK?.amount_per_turnover_group).forEach(
              (paymentMethodKey) => {
                let paymentMethod =
                  receipt.reporting.total_amount_per_transaction.OK?.amount_per_turnover_group[paymentMethodKey];

                addAmounts(
                  newSalesArea,
                  paymentMethodKey,
                  paymentMethod,
                  receipt.reporting.total_amount_per_transaction.OK.vats,
                  totalAmount
                );
              }
            );
          }
        }
      });

      Object.keys(newSalesArea.amountPerPaymentType).forEach((paymentMethod) => {
        Object.keys(newSalesArea.amountPerPaymentType[paymentMethod].vats).forEach((vat) => {
          if (vat === "count") {
            return;
          }
          newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountExVat = Math.round(
            newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountIncVat / (1 + Number(vat))
          );
          newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountVat =
            newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountIncVat -
            newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountExVat;
        });

        newSalesArea.amountPerPaymentType[paymentMethod].total = { amountIncVat: 0, amountExVat: 0, amountVat: 0 };
        Object.keys(newSalesArea.amountPerPaymentType[paymentMethod].vats).forEach((vat) => {
          if (vat === "total") {
            return;
          }
          newSalesArea.amountPerPaymentType[paymentMethod].total.amountExVat +=
            newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountExVat;
          newSalesArea.amountPerPaymentType[paymentMethod].total.amountVat +=
            newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountVat;
          newSalesArea.amountPerPaymentType[paymentMethod].total.amountIncVat +=
            newSalesArea.amountPerPaymentType[paymentMethod].vats[vat].amountIncVat;
        });
      });
      salesAreasDataArray.push(newSalesArea);
    });

    setSalesAreaData(salesAreasDataArray);
  };

  return (
    <Grid container>
      <Typography gutterBottom variant="h5" style={{ textAlign: "left" }}>
        {props.intl.formatMessage({ id: "reporting_sales_areas" })}
      </Typography>
      <Grid item xs={12}>
        {fetching ? (
          <div align="center">
            <CircularProgress color="primary" />
          </div>
        ) : (
          <Grid container spacing={2}>
            <Grid item xxs={12} md={6}>
              <SearchSalesArea
                // key={[...selectedItems].length}
                handleReportData={() => {
                  setFetching(true);
                  getReportingData(cloudStore.merchant.id, selectedTaMerchantIds, selectedSpMerchantIds, range)
                    .catch((err) => setFetching(false))
                    .then((res) => {
                      setFetching(false);
                      handleReportData(res);
                    });
                }}
                handleSetMerchantIds={handleSetMerchantIds}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DateRangePicker
                locale={enGB}
                weekStartsOn={1}
                maxDate={new Date()}
                ranges={[range]}
                onChange={(newRange) => {
                  if (
                    newRange.selection.startDate !== range.startDate ||
                    newRange.selection.endDate !== range.endDate
                  ) {
                    setRange({
                      key: "selection",
                      startDate: newRange.selection.startDate,
                      endDate: newRange.selection.endDate
                    });
                  }
                }}
              />
            </Grid>
            <Button
              style={{ margin: 20 }}
              fullWidth
              onClick={() => {
                setFetching(true);
                if (selectedItems.length > 0) {
                  getReportingData(
                    cloudStore.merchant.id,
                    selectedTaMerchantIds,
                    selectedSpMerchantIds,
                    range,
                    props.intl.formatMessage({ id: "report_generated" }),
                    props.intl.formatMessage({ id: "failed_to_generate_report" })
                  )
                    .catch((err) => setFetching(false))
                    .then((res) => {
                      setFetching(false);
                      handleReportData(res);
                    });
                } else {
                  alert(props.intl.formatMessage({ id: "select_sales_areas" }));
                  setFetching(false);
                }
              }}
            >
              {salesAreaData.length > 0
                ? props.intl.formatMessage({ id: "regenerate_reports" })
                : props.intl.formatMessage({ id: "generate_reports" })}
            </Button>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12}>
        {salesAreaData.length > 0 && <ReportingTable salesAreas={salesAreaData} />}
      </Grid>
    </Grid>
  );
}

export default withIntl(Reporting);
